"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.typesMap = void 0;
var BaseCardProps_1 = require("./BaseCardProps");
var styles = require("./BaseCard.css");
exports.typesMap = (_a = {},
    _a[BaseCardProps_1.BaseCardType.DEFAULT] = styles.defaultSize,
    _a[BaseCardProps_1.BaseCardType.DTVNOWBASE] = styles.dtvnowBaseoffer,
    _a[BaseCardProps_1.BaseCardType.DTVNOWHARDWARE] = styles.dtvnowHardwareoffer,
    _a[BaseCardProps_1.BaseCardType.DTVNOWPREMIUM] = styles.dtvnowPremiumchannel,
    _a[BaseCardProps_1.BaseCardType.DTVNOWCDVR] = styles.dtvnowCdvr,
    _a[BaseCardProps_1.BaseCardType.DTVNOWSTREAM] = styles.dtvnowStream,
    _a[BaseCardProps_1.BaseCardType.WIRELESSDEVICE] = styles.wirelessDeviceoffer,
    _a);
//# sourceMappingURL=BaseCardStylesMaps.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/cards/BaseCard/BaseCardStylesMaps.js
// module id = 1303
// module chunks = 8